import { render } from "./indexfivedoctor.vue?vue&type=template&id=4c1497f1"
import script from "./indexfivedoctor.vue?vue&type=script&lang=js"
export * from "./indexfivedoctor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__